<template>
  <router-view v-slot="{ Component }">
    <transition name="route-page">
      <keep-alive :include="keepAliveInclude" :max="1">
        <component :is="Component" :key="viewKey" />
      </keep-alive>
    </transition>
  </router-view>
</template>

<script>
export default {
  name: 'RouteView',
  props: {
    viewKey: { type: String, default: undefined },
    keepAliveInclude: { type: [String, Array], default: () => [] }
  }
};
</script>

<style>
.route-page-enter-active {
  animation: route-page-enter 160ms ease-out;
}

@keyframes route-page-enter {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .route-page-enter-active {
    animation: none;
  }
}
</style>
